import { useState, useCallback, useEffect, useMemo } from "react";
import { useFieldInitialData } from "../../../contexts/field-initial-data-context.js";
const useServiceOptionsBase = (config) => {
  const {
    fieldType,
    isEditor = false,
    postProcessOptions,
    customFetchLogic,
    onInitialDataLoaded
  } = config;
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [isEmpty, setIsEmpty] = useState(false);
  const [hasInitialDataLoaded, setHasInitialDataLoaded] = useState(false);
  const initialData = useFieldInitialData(fieldType);
  const processOptions = useCallback(
    (services) => {
      let enrichedOptions = services.map((service) => ({
        value: service.id ?? "",
        label: service.name ?? "",
        id: service.id ?? ""
      }));
      if (postProcessOptions) {
        enrichedOptions = postProcessOptions(enrichedOptions);
      }
      return enrichedOptions;
    },
    [postProcessOptions]
  );
  useEffect(() => {
    if (initialData?.services) {
      const processedOptions = processOptions(initialData.services);
      setOptions(processedOptions);
      setIsEmpty(processedOptions.length === 0);
      setHasInitialDataLoaded(true);
      if (onInitialDataLoaded) {
        onInitialDataLoaded(processedOptions);
      }
    }
  }, [initialData, processOptions, onInitialDataLoaded]);
  useEffect(() => {
    if (customFetchLogic && !isEditor) {
      customFetchLogic();
    }
  }, [customFetchLogic, isEditor]);
  const shouldRender = useMemo(() => {
    return isEditor || hasInitialDataLoaded;
  }, [isEditor, hasInitialDataLoaded]);
  return {
    isLoading,
    options,
    isEmpty,
    hasInitialDataLoaded,
    shouldRender,
    setIsLoading,
    setOptions,
    setIsEmpty,
    setHasInitialDataLoaded,
    processOptions
  };
};
export {
  useServiceOptionsBase
};
//# sourceMappingURL=use-service-options-base.js.map
